import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import LandingPage from '../LandingPage';
import GetStartedPage from '../../getStarted';
import ProfileComplete from '../ProfileComplete/ProfileComplete';
import { useHistory } from 'react-router-dom';
import AccessDeniedPage from '../AccessDeniedPage';
import { userSelector, userTagsSelector } from 'redux/selectors/userSelector';
import { useSelector } from 'react-redux';
import { isInitialSetupCompleted } from 'utils/userUtils';

export default function HomePage() {
	const { isAuthenticated, error, user, logout } = useAuth0();
	const history = useHistory();
	const userData = useSelector(userSelector);
	const userTags = useSelector(userTagsSelector);

	if (user) {
		// history.push('/profile-information');
		return null;
	} else if (error) {
		logout({
			returnTo: window.location.origin,
		});
		return null;
	} else {
		return <GetStartedPage />;
	}
}
